import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
import React from "react";
var __jsx = React.createElement;
const BackArrowIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6875 6.5C18.6875 6.13756 18.3937 5.84375 18.0312 5.84375L2.55308 5.84375L6.68279 1.71404C6.93907 1.45776 6.93907 1.04224 6.68279 0.785961C6.42651 0.529679 6.01099 0.529679 5.75471 0.785961L0.504711 6.03596C0.248429 6.29224 0.248429 6.70776 0.504711 6.96404L5.75471 12.214C6.01099 12.4703 6.42651 12.4703 6.68279 12.214C6.93907 11.9578 6.93907 11.5422 6.68279 11.286L2.55308 7.15625L18.0312 7.15625C18.3937 7.15625 18.6875 6.86244 18.6875 6.5Z",
    fill: color
  }));
};
export default BackArrowIcon;